export default {
    addresses: [],
    addressesLoading: false,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        search: ''
    }
}